const initialState = {
    filter: {
        isVisible: false,
        value: null,
    },
    layers: [],
    savedGroupVisibility: {},
    enableCustomLayers: false,
};
export const getInitialState = () => initialState;
//# sourceMappingURL=initialState.js.map